// JavaScript Document
jQuery('.carousel-inner').each(function() {
    if (jQuery(this).children('div').length === 1)
        jQuery(this).siblings('.carousel-control-prev, .carousel-control-next, .carousel-indicators').hide();
});

jQuery(document).ready(function($) {
jQuery('.stellarnav').stellarNav({
theme: 'light',
breakpoint: 991,
position: 'right',
  showArrows: false,
  openingSpeed: 150, // how fast the dropdown should open in milliseconds
			closingDelay: 150,
});
});


jQuery('.fadeSlider').slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 3000,
    fade: true,
    cssEase: 'cubic-bezier'
});

jQuery(".testimonials").slick({
  dots: true,
  centerMode: true,
  slidesToShow: 3,
  centerPadding: '0px',
  responsive: [{
            breakpoint: 768,
            settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '40px',
                slidesToShow: 1
            }
        },
        {
            breakpoint: 575,
            settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '20px',
                slidesToShow: 1
            }
        }
    ]
});

jQuery('.slider-multi').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true
});

jQuery('.videoslider').slick({
    centerMode: true,
    dots: false,
    arrows: false,
    infinite: true,
    centerPadding: '140px',
    slidesToShow: 1,
    responsive: [{
            breakpoint: 768,
            settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '40px',
                slidesToShow: 1
            }
        },
        {
            breakpoint: 575,
            settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '20px',
                slidesToShow: 1
            }
        }
    ]
});


jQuery('.profit-items').slick({
    centerMode: true,
    centerPadding: '20px',
    slidesToShow: 3,
    infinite: true,
    autoplay: true,
    dots: false,
    arrows: false,
    responsive: [{
            breakpoint: 1199,
            settings: {
                arrows: false,
                centerMode: false,
                centerPadding: '20px',
                slidesToShow: 3
            }
        },
        {
            breakpoint: 991,
            settings: {
                arrows: false,
                centerMode: false,
                centerPadding: '40px',
                slidesToShow: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
                arrows: false,
                centerMode: false,
                centerPadding: '40px',
                slidesToShow: 1
            }
        }
    ]
});

jQuery('.product-items').slick({
    centerPadding: '40px',
    slidesToShow: 3,
    infinite: false,
    autoplay: false,
    dots: false,
    arrows: false,
    responsive: [{
            breakpoint: 1199,
            settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '40px',
                slidesToShow: 3
            }
        },
        {
            breakpoint: 991,
            settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '40px',
                slidesToShow: 3
            }
        },
        {
            breakpoint: 480,
            settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '10px',
                slidesToShow: 1
            }
        }
    ]
});


jQuery('.marquee-with-options').marquee({
    speed: 18000,
    gap: 0,
    delayBeforeStart: 0,
    direction: 'left',
    duplicated: true,
    pauseOnHover: true
});


jQuery('.coleql_height').matchHeight();


var cards = jQuery('#card-slider .slider-item').toArray();

startAnim(cards);

function startAnim(array) {
    if (array.length >= 4) {
        TweenMax.fromTo(array[0], 0.5, {
            x: 0,
            y: 0,
            opacity: 0.75
        }, {
            x: 0,
            y: -120,
            opacity: 0,
            zIndex: 0,
            delay: 0.03,
            ease: Cubic.easeInOut,
            onComplete: sortArray(array)
        });

        TweenMax.fromTo(array[1], 0.5, {
            x: 0,
            y: 125,
            opacity: 1,
            zIndex: 1,
            scaleX: 0.8,
            scaleY: 0.8
        }, {
            scaleX: 0.8,
            scaleY: 0.8,
            x: 0,
            y: 0,
            opacity: 0.75,
            zIndex: 0,
            boxShadow: '-5px 8px 8px 0 rgba(82,89,129,0.05)',
            ease: Cubic.easeInOut
        });

        TweenMax.to(array[2], 0.5, {
            bezier: [{
                x: 0,
                y: 250
            }, {
                x: 0,
                y: 200
            }, {
                x: 0,
                y: 125
            }],
            boxShadow: '-5px 8px 8px 0 rgba(82,89,129,0.05)',
            zIndex: 1,
            opacity: 1,
            ease: Cubic.easeInOut,
          scaleX: 1,
            scaleY: 1
        });

        TweenMax.fromTo(array[3], 0.5, {
            x: 0,
            y: 400,
            opacity: 0,
            zIndex: 0,
          scaleX: 0.8,
            scaleY: 0.8
        }, {
          scaleX: 0.8,
            scaleY: 0.8,
            x: 0,
            y: 250,
            opacity: 0.75,
            zIndex: 0,
            ease: Cubic.easeInOut
        }, );
    } else {
        jQuery('#card-slider').append('<p>Sorry, carousel should contain more than 3 slides</p>')
    }
}

function sortArray(array) {
    clearTimeout(delay);
    var delay = setTimeout(function() {
        var firstElem = array.shift();
        array.push(firstElem);
        return startAnim(array);
    }, 6000)
}
jQuery(document).ready(function() {
    jQuery(".dropdown").hover(
        function() {
            jQuery('.dropdown-menu', this).stop(true, true).slideDown("slow");
            jQuery(this).toggleClass('open');
        },
        function() {
            jQuery('.dropdown-menu', this).stop(true, true).slideUp("slow");
            jQuery(this).toggleClass('open');
        }
    );
});

jQuery(document).ready(function() {
    jQuery('.channel-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: false,
        autoplay: false,
        
    });

    
    
});

jQuery("ul.navbar-nav > li:not('.no-submenu')").mouseover(function() {
    jQuery("body").addClass("hover-active");
});
jQuery("ul.navbar-nav > li:not('.no-submenu')").mouseleave(function() {
    jQuery("body").removeClass("hover-active");
});

//--24-10-22
jQuery('.multiple-items').owlCarousel({
    loop: true,
    arrows: false,
    dots: false,
    nav: false,
    margin: 30,
    responsiveClass: true,
    responsive: {
        0: {
            items: 1,
            nav: false,
            margin:0
        },
        600: {
            items: 1.6,
            nav: false
        },
        1000: {
            items: 1.6,
            nav: false,
            
        }
    }
})

jQuery('.multiple-items2').owlCarousel({
    loop: true,
    arrows: false,
    dots: false,
    nav: false,
    margin: 10,
    center:true,
    autoplay:true,
    responsiveClass: true,
    responsive: {
        0: {
            items: 4,
            nav: false,
            margin:0
        },
        600: {
            items: 4,
            nav: false
        },
        1000: {
            items: 6,
            nav: false,
            
        }
    }
})

jQuery('.multiple-items3').owlCarousel({
    loop: true,
    arrows: false,
    dots: true,
    nav: false,
    margin: 10,
    responsiveClass: true,
    responsive: {
        0: {
            items: 1,
            nav: false,
            margin:0
        },
        600: {
            items: 2,
            nav: false
        },
        1000: {
            items: 3,
            nav: false,
            
        }
    }
})
jQuery('.multiple-items4').owlCarousel({
    loop: true,
    arrows: false,
    dots: true,
    nav: false,
    margin: 10,
    responsiveClass: true,
    responsive: {
        0: {
            items: 1,
            nav: false,
            margin:0
        },
        600: {
            items: 2,
            nav: false
        },
        1000: {
            items: 3,
            nav: false,
            
        }
    }
})
//--24-10-22

jQuery('.bottom-items').owlCarousel({
loop:true,
arrows:false,
dots:false,
nav:false,
margin:30,
responsiveClass:true,
responsive:{
0:{
items:1,
nav:false,
  dots:true,
},
600:{
items:1,
nav:false,
  dots:true,
},
1000:{
items:1,
nav:false,
loop:false,
  dots:true,
}
}
})

jQuery(".text-carousel").owlCarousel({
  loop: true,
  autoplay: true,
  items: 1,
  nav: false,
  rtl:true,
  dots: false,
  autoplayHoverPause: true,
  autoplayTimeout:1500,
  animateOut: 'slideOutDown',
  animateIn: 'slideInDown',
  slideTransition:'linear'
});

jQuery('.bannerslider').slick({
  dots: false,
  dots: false,
  arrows: false,
  speed: 500,
  fade: true,
  cssEase: 'linear'
});

jQuery('.marketing-slider').owlCarousel({
loop:true,
  autoplay:true,
arrows:false,
nav:false,
margin:45,
responsiveClass:true,
responsive:{
0:{
items:1,
nav:false,
  dots:true,
},
600:{
items:1,
nav:false,
  dots:true,
},
1000:{
items:3,
nav:false,

  dots:false,
}
}
})

/*jQuery('.marketing-slider').slick({
  infinite: true,
  dots: false,
  arrows: false,
  speed: 500,
  autoplay: true,
  
  slidesToShow: 3,
  responsive: [
        {
            breakpoint: 480,
            settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '40px',
                slidesToShow: 1
            }
        }
    ]
  
});*/

jQuery('.home-profit-items').slick({
    centerMode: true,
    centerPadding: '20px',
    slidesToShow: 3.25,
    infinite: true,
    autoplay: true,
    dots: false,
    arrows: false,
    responsive: [{
            breakpoint: 1199,
            settings: {
                arrows: false,
                centerMode: false,
                centerPadding: '10px',
                slidesToShow: 3.25
            }
        },
        {
            breakpoint: 991,
            settings: {
                arrows: false,
                centerMode: false,
                centerPadding: '40px',
                slidesToShow: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
                arrows: false,
                centerMode: false,
                centerPadding: '40px',
                slidesToShow: 1
            }
        }
    ]
});


jQuery('.opti-items').slick({
  centerMode: true,
  centerPadding: '0px',
  slidesToShow: 3,
  dots: false,
  speed:300,
  infinite: true,
  responsive: [
        {
            breakpoint: 480,
            settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '40px',
                slidesToShow: 1
            }
        }
    ]

  
});


jQuery('.readmore-fire').on('click', function(){
  jQuery('#'+jQuery(this).attr('data-target')).addClass('expanded');
  if(jQuery(this).hasClass('readmore')){
    jQuery('.readmore-fire[data-target="'+jQuery(this).attr('id')+'"]').not(this).hide();
  }else{
    jQuery(this).hide();
  }
});

//Slick Carousel
jQuery('.CareersSlider').slick({
dots: true,
infinite: true,
autoplay: true,
arrows: false,
speed: 300,
slidesToShow: 3,
slidesToScroll: 1,
responsive: [
{
breakpoint: 992,
settings: {
slidesToShow: 3,
slidesToScroll: 1,
}
},
{
breakpoint: 992,
settings: {
slidesToShow: 2,
slidesToScroll: 1
}
},
{
breakpoint: 575,
settings: {
slidesToShow: 1,
slidesToScroll: 1
}
}
]
});
